import CardsList from "@/components/cardsList";
import { ONEMIND_NDT_CONSTANTS } from "./constants";
import { Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";

const OfferingsComponent = () => {
  const TextVariant = useTextVariant();
  return (
    <Stack gap={6} align={"center"}>
      <CardsList
        columns={{ base: 1, sm: 3 }}
        title={ONEMIND_NDT_CONSTANTS.title}
        list={ONEMIND_NDT_CONSTANTS.list}
        spacing={{ base: 8, md: 16 }}
        hoverEffect
      />
      <Text variant={TextVariant} color="text.100">
        {ONEMIND_NDT_CONSTANTS.conclusion}
      </Text>
    </Stack>
  );
};

export default OfferingsComponent;
